module.exports = __webpack_public_path__ + "media/images/page/public_assistance/img_01-00436116a6913204861a9c09ed264c23.png";